if (!customElements.get('brand-video')) {
  customElements.define(
    'brand-video',
    class BrandVideo extends HTMLElement {
      constructor() {
        super();
        this.onTriggerClick = this.onTriggerClick.bind(this);
      }

      connectedCallback() {
        this.trigger = this.querySelector('.brand-video__trigger');
        this.trigger?.addEventListener('click', this.onTriggerClick);
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.onTriggerClick);
      }

      onTriggerClick() {
        const media = this.querySelector('.brand-video__media');
        if (!media) {
          return;
        }

        const isMobile = !window.matchMedia('(min-width: 769px)').matches;
        const template = isMobile
          ? media.querySelector('[data-video-template-mobile]') || media.querySelector('[data-video-template]')
          : media.querySelector('[data-video-template]');
        const embed = template ? template.content.cloneNode(true) : this.buildIframe(isMobile);
        if (!embed) {
          return;
        }

        media.replaceChildren(embed);
        this.trigger.replaceWith(media);
        this.trigger = null;
      }

      buildIframe(isMobile) {
        const url = (isMobile && this.dataset.videoUrlMobile) || this.dataset.videoUrl;
        if (!url) {
          return null;
        }

        const src = BrandVideo.embedSrc(url);
        if (!src) {
          return null;
        }

        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.setAttribute('frameborder', '0');
        iframe.title = this.trigger?.getAttribute('aria-label') || '';
        return iframe;
      }

      static embedSrc(url) {
        if (url.includes('youtube.com') || url.includes('youtu.be')) {
          const id = url.includes('youtu.be') ? url.split('youtu.be/')[1]?.split(/[?&]/)[0] : new URL(url).searchParams.get('v');
          return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0&playsinline=1` : null;
        }

        if (url.includes('vimeo.com')) {
          const id = url.split('vimeo.com/')[1]?.split(/[?&/]/)[0];
          return id ? `https://player.vimeo.com/video/${id}?autoplay=1` : null;
        }

        return null;
      }
    },
  );
}
